import ObjectListController from "./object_list_controller"

export default class PortfoliosObjectListController extends ObjectListController {
  connect() {
    super.connect()
  }

  onAdd(portfolios) {
    this.portfolios = portfolios

    window.Turbo.visit(this.addItemUrlValue, { frame: "modal" })
  }
}
